import { activateFreePlan } from '@/core/services/payments/payment-functions.service';

export type ActivateFreePlanInput = {
  plan_id: string;
};

/**
 * Ativa `subscriptions/current` com plano gratuito (callable `activateFreePlan`).
 */
export class ActivateFreePlanUseCase {
  async execute(input: ActivateFreePlanInput): Promise<void> {
    await activateFreePlan(input.plan_id);
  }
}
